const IMAGES = [
  {
    url: "https://images.unsplash.com/photo-1660540056047-363e5ae4de80",
    alt: "Copper macro",
    span: "md:col-span-2 md:row-span-2",
  },
  {
    url: "https://images.unsplash.com/photo-1640602344715-a6ef5c281037",
    alt: "Copper wires bundle",
    span: "",
  },
  {
    url: "https://images.unsplash.com/photo-1714352069805-e0bf94d1381f",
    alt: "Copper close-up",
    span: "",
  },
  {
    url: "https://images.unsplash.com/photo-1717667745852-a5bd6876c1de",
    alt: "Wires pile",
    span: "md:col-span-2",
  },
  {
    url: "https://images.pexels.com/photos/4487383/pexels-photo-4487383.jpeg",
    alt: "Warehouse",
    span: "",
  },
  {
    url: "https://images.pexels.com/photos/11666903/pexels-photo-11666903.jpeg",
    alt: "Loading dock",
    span: "",
  },
];

export default function Gallery() {
  return (
    <div data-testid="page-gallery" className="max-w-7xl mx-auto px-6 lg:px-10 py-20 lg:py-28">
      <p className="label-eyebrow">/ Gallery</p>
      <h1 className="font-heading mt-4 text-4xl md:text-6xl font-black uppercase tracking-tighter">
        Physical inventory. <br />
        <span className="copper-text">Documented.</span>
      </h1>
      <p className="mt-6 text-zinc-400 max-w-xl">
        A visual record of material on hand and operations on the ground. Live
        site visits and verification calls available on request.
      </p>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-4 auto-rows-[260px] gap-4">
        {IMAGES.map((img, i) => (
          <div
            key={i}
            data-testid={`gallery-tile-${i}`}
            className={`relative overflow-hidden border border-zinc-800 group ${img.span}`}
          >
            <img
              src={img.url}
              alt={img.alt}
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
            <div className="absolute bottom-3 left-3 right-3 flex items-center justify-between opacity-0 group-hover:opacity-100 transition-opacity">
              <span className="label-eyebrow text-zinc-200">
                / {String(i + 1).padStart(2, "0")}
              </span>
              <span className="text-xs uppercase tracking-widest text-zinc-200">
                {img.alt}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
